function init() {
	if (!document.querySelector('form[name]')) return;

	BX.addCustomEvent('onAjaxSuccess', () => {
		const forms = document.querySelectorAll('form[name]');
		forms.forEach((form) => {
			if (!form.querySelector('.notetext')) return; // skip not submitted forms

			const name = form.getAttribute('name');
			if (!name) return;

			if (window.gtag) {
				window.gtag('event', 'submit', {
					event_category: 'form',
					event_label: name,
				});
			}
		});
	});
}

init();
